import { createRequest, RequestConfig } from 'app/common/api';

import { TUpdatedRouteRefund } from '../core/route-refund-rule';

const config: RequestConfig = {
  method: 'post',
  url: '/ws/api/update_route_refund_rule',
};

export const updateRouteRefundRequest = (routeRefund: TUpdatedRouteRefund) =>
  createRequest({
    url: config.url,
    method: config.method,
    body: JSON.stringify(routeRefund),
  });
